import {IBundleType} from "../bundle-types/bundle-type.interface";
import {NullableString} from "../../types/nullable-types";

export enum BundleCodes {
    ABAS = 'ABAS',
    BPLU = 'BPLU',
    CBIZ = 'CBIZ',
    CBCM = 'CBCM',
    ABPS = 'ABPS',
    PSOR = 'PSOR',
    CORR = 'CORR',
    ABMR = 'ABMR',
    ABWK = 'ABWK',
    CHDP = 'CHDP',
    PSOS = 'PSOS',
    PSOF = 'PSOF',
    PSOT = 'PSOT'
}

export interface IBundleTypesConfiguration {
    bundlesDisplayOrder: IBundleType[];
}

export interface IBundleTypesConfigurationService {
    getConfiguration(): IBundleTypesConfiguration;
}


export function isChildBundleCode(bundleCode: NullableString): boolean {
    return bundleCode === BundleCodes.CHDP;
}